import { QUESTIONNAIRE_DETAIL, SKIPPER_CUSTOMER_DETAIL } from "./coach";
import { PROGRAM_REQUIRED_FIELD } from "./program";

export const CUSTOMER_DETAIL_TYPE = {
  ACCOUNT_CREATION_TRACKED: "ACCOUNT_CREATION_TRACKED",
  ACCOUNT_REMOVAL_TRACKED: "ACCOUNT_REMOVAL_TRACKED",
  ACCEPTED_DREAMBOUND_TERMS: "ACCEPTED_DREAMBOUND_TERMS",
  ACCEPTED_TERMS_VERSION: "ACCEPTED_TERMS_VERSION",
  ACCOUNT_CREATION_FUNNEL: "ACCOUNT_CREATION_FUNNEL",
  ADDRESS: "ADDRESS",
  CHEQ_REQUEST: "CHEQ_REQUEST",
  CHEQ_VALIDATION_RESULT: "CHEQ_VALIDATION_RESULT",
  COACH_STATE: "COACH_STATE",
  COACH_STYLE: "COACH_STYLE",
  COACH_THREAD_ID: "COACH_THREAD_ID",
  DOB: "DOB",
  EDUCATION_LEVEL: "EDUCATION_LEVEL",
  ENROLL_LIKELIHOOD: "ENROLL_LIKELIHOOD",
  PROGRAM_ENVIRONMENT: "PROGRAM_ENVIRONMENT",
  EVERFLOW_CLICK: "EVERFLOW_CLICK",
  EVERFLOW_DATA: "EVERFLOW_DATA",
  EVERFLOW_NETWORK_ID: "EVERFLOW_NETWORK_ID",
  EVERFLOW_TRANSACTION_ID: "EVERFLOW_TRANSACTION_ID",
  EVERFLOW_TRANSACTION_ID_PUBLIC: "EVERFLOW_TRANSACTION_ID_PUBLIC",
  EXPERIMENTS: "EXPERIMENTS",
  FB_PIXEL_BROWSER_ID: "FB_PIXEL_BROWSER_ID",
  FB_PIXEL_CLICK_ID: "FB_PIXEL_CLICK_ID",
  GOOGLE_CLICK_ID: "GOOGLE_CLICK_ID",
  GOOGLE_WBRAID: "GOOGLE_WBRAID",
  GOOGLE_GBRAID: "GOOGLE_GBRAID",
  INTENDED_VOCATION_ID: "INTENDED_VOCATION_ID",
  INTENDED_WHITE_LABEL_PROGRAM_ID: "INTENDED_WHITE_LABEL_PROGRAM_ID",
  LANDING_AFFILIATE: "LANDING_AFFILIATE",
  PERSONAL_INFO_REMOVED: "PERSONAL_INFO_REMOVED",
  TRACKING_PARAMS: "TRACKING_PARAMS",
  PROGRAM_LEVEL_PREFERENCE: "PROGRAM_LEVEL_PREFERENCE",
  VACCINATION_STATUS: "VACCINATION_STATUS",
  REFERRER: "REFERRER",
  LANDING_URL: "LANDING_URL",
  ...PROGRAM_REQUIRED_FIELD,
  ...SKIPPER_CUSTOMER_DETAIL,
  ...QUESTIONNAIRE_DETAIL,
} as const;

export const DOB_FORMAT = "yyyy-MM-dd";

export type CustomerDetailType = (typeof CUSTOMER_DETAIL_TYPE)[keyof typeof CUSTOMER_DETAIL_TYPE];

export const VACCINATION_STATUS = [
  "YES_COMPLETE",
  "YES_PARTIAL",
  "NO_WILLING",
  "NO_UNWILLING",
] as const;

export type VaccinationStatus = (typeof VACCINATION_STATUS)[number];

export const EDUCATION_LEVEL = {
  NO_HS_DIPLOMA_GED: "NO_HS_DIPLOMA_GED",
  CURRENT_HIGH_SCHOOL: "CURRENT_HIGH_SCHOOL",
  HIGH_SCHOOL_DIPLOMA_GED: "HIGH_SCHOOL_DIPLOMA_GED",
  SOME_COLLEGE: "SOME_COLLEGE",
  ASSOCIATE: "ASSOCIATE",
  BACHELOR: "BACHELOR",
  MASTER: "MASTER",
  DOCTORAL: "DOCTORAL",
} as const;

export type EducationLevel = (typeof EDUCATION_LEVEL)[keyof typeof EDUCATION_LEVEL];

export const educationLevelFriendlyNameMap = {
  [EDUCATION_LEVEL.NO_HS_DIPLOMA_GED]: "No High School Diploma/GED",
  [EDUCATION_LEVEL.CURRENT_HIGH_SCHOOL]: "Current high school student",
  [EDUCATION_LEVEL.HIGH_SCHOOL_DIPLOMA_GED]: "High school diploma/GED",
  [EDUCATION_LEVEL.SOME_COLLEGE]: "Some college",
  [EDUCATION_LEVEL.ASSOCIATE]: "Associate's Degree",
  [EDUCATION_LEVEL.BACHELOR]: "Bachelor's Degree",
  [EDUCATION_LEVEL.MASTER]: "Master's Degree",
  [EDUCATION_LEVEL.DOCTORAL]: "Doctorate Degree",
};

export const COACH_STYLE = {
  FRIENDLY: "FRIENDLY",
  PROFESSIONAL: "PROFESSIONAL",
  AGGRESSIVE: "AGGRESSIVE",
} as const;

export type CoachStyle = (typeof COACH_STYLE)[keyof typeof COACH_STYLE];

export const PROGRAM_LEVEL_PREFERENCE = {
  CERTIFICATE: "CERTIFICATE",
  DEGREE: "DEGREE",
} as const;

export type ProgramLevelPreference =
  (typeof PROGRAM_LEVEL_PREFERENCE)[keyof typeof PROGRAM_LEVEL_PREFERENCE];

export const coachStyleFriendlyNameMap = {
  [COACH_STYLE.FRIENDLY]: "Friendly",
  [COACH_STYLE.PROFESSIONAL]: "Professional",
  [COACH_STYLE.AGGRESSIVE]: "Aggressive",
};

export const ACCOUNT_CREATION_FUNNEL = {
  PROGRAM_PAGE: "PROGRAM_PAGE",
  MODAL: "MODAL",
  SKIPPER_COACH: "SKIPPER_COACH",
  SKIPPER_FORM: "SKIPPER_FORM",
  SIGN_IN: "SIGN_IN",
  FORM_FUNNEL: "FORM_FUNNEL",
} as const;

export type AccountCreationFunnel =
  (typeof ACCOUNT_CREATION_FUNNEL)[keyof typeof ACCOUNT_CREATION_FUNNEL];

export const ACCEPTED_TERMS_VERSION = {
  V2021_02_26: "V2021_02_26",
  V2024_07_08: "V2024_07_08",
  V2025_02_10: "V2025_02_10",
} as const;

export type AcceptedTermsVersion =
  (typeof ACCEPTED_TERMS_VERSION)[keyof typeof ACCEPTED_TERMS_VERSION];
